<template>
  <FormularioBase
    :tiposPermitidos="['ACESSO_DADOS_PESSOAIS', 'INCIDENTE_DADOS_PESSOAIS']"
    sistema="B2B"
    moduloKey="ADMIN_FORMULARIOS"
    tabTitulo="Formulários"
    context="LGPD"
  />
</template>

<script>
import FormularioBase from "../../components/formularios/FormularioBase.vue";
export default { components: { FormularioBase } };
</script>
